
import { mapState } from "vuex";
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import { go } from "./../../util/router";
import {
getHomeImage,
getHomePageSeries,
getHomePageCommodity,
GetBanners
} from "./../../service/index";
export default {
data() {
return {
ImgUrl: [],
MenuList: [], // 按钮列表/22.02.29
SeriesList: [],
CommodityList: [],
pageIndex: 0,
pageSize: 10,
pageCount: 0,
isLock: false,

hotWidth: 375,
scrollLeft: 0,

bind_P: ""
};
},
components: { Swiper, SwiperItem },
created() {


GetBanners(result => {
console.log("=banner=", JSON.parse(result.data));
if (result.code === "1") {

this.ImgUrl = JSON.parse(result.data).Banners;
this.MenuList = JSON.parse(result.data).Icons;


console.log('---',document.getElementsByClassName('vux-swiper'));
}
});
},
mounted() {

let _P = localStorage.getItem("_P");
if (_P) {
this.bind_P = "?p=" + _P;
}
this.getHomePageSeries();
this.getHomePageCommodity();

this.$refs.viewBox.addEventListener("scroll", this.scrool);
this.$refs.viewBox.scrollLeft = this.scrollLeft;
},
watch: {
$route: function(to, from) {

this.$refs.viewBox.scrollLeft = this.scrollLeft;
}
},
methods: {

scrool() {
this.scrollLeft = this.$refs.viewBox.scrollLeft;
},
DoList(item) {

this.$router.push({
path: item.LinkUrl,
query: {
bannerName: item.Name,

MARA_MTART: item.MARA_MTART, //专区id
bannerOId: item.OId 
}
});
},
doProListXH() {

go("/prolist/0/0", this.$router);
},
doProList(oid) {

go("/prolistdis/1/" + oid, this.$router);
},
doDetail(oid) {
this.$router.push({ path: "/Detail/" + oid, query: { otype: "XHXP" } }); 

},
getHomeImage() {
let vm = this;
getHomeImage(result => {

if (result.code === "1") {
let ls = JSON.parse(result.data);
vm.ImgUrl = ls.PhotoUrl;
}
});
},
getHomePageSeries() {
let vm = this;
getHomePageSeries(result => {
if (result.code === "1") {

let ls = JSON.parse(result.data);
for (let item of ls) {
if (item.PhotoUrl) {
vm.SeriesList.push(item);
}
}

console.log(JSON.parse(result.data));
let d = document.querySelector("#hotSeries");
this.hotWidth = 230 * ls.length;

setTimeout(() => {
let imgs = d.getElementsByTagName("img");
let w = 0;
for (let img of imgs) {
w += img.width + 5;
}

this.hotWidth = w;
this.$refs.viewBox.scrollLeft = this.scrollLeft;
}, 500);
}
});
},
getHomePageCommodity() {
let vm = this;
let pData = {
pageNum: vm.pageIndex,
pageSize: 10
};
vm.isLock = true;
getHomePageCommodity(pData, result => {
vm.isLock = false;
console.log(JSON.parse(result.data));
if (result.code === "1") {
let ls = JSON.parse(result.data);
for (let item of ls) {
vm.CommodityList.push(item);
}
}
});
},
pagescroll() {
let self = this;
window.onscroll = function() {
let body = document.body;
let scrollTop =
body.scrollTop === 0
? document.documentElement.scrollTop
: body.scrollTop;
let dHeight = body.scrollHeight;
let height = document.documentElement.clientHeight;
if (self.isT) {
return;
}

if (scrollTop + height >= dHeight - 100) {
if (self.pageCount - self.pageIndex * self.pageSize > self.pageSize) {
if (!self.isLock) {
self.isLock = true;
self.pageIndex += 1;
self.getHomePageCommodity();
}
}
}
};
}
},
computed: {
...mapState({
route: state => state.route,
path: state => state.route.path
})
}
};



// WEBPACK FOOTER //
// ./src/page/home/default.vue